import { useParams } from "react-router-dom"
import { apiClient } from "../../../infra/api-client"
import { getUserSession } from "../../../common/session/user-session"
import { Header } from "./header"
import { useEffect, useState } from "react"
import { ActivityGame, GameAttempt, GameMetatdata } from "../../../modules/games/game"
import { gamesLookupService } from "../../../modules/games/games-lookup"
import { ActivityAttempt, LessonActivity } from "../../../modules/lesson/activity/activity.types"
import { BASE_URL } from "../../../global"
import { ArcademicsSummary } from "../../../modules/games/game-arcademics"
import { StandardLonghandProperties } from "csstype"

type GameSession = {
  activityAttempts: ActivityAttempt[],
  gameSessions: GameAttempt[]
  rewards: {
    coinsEarned: number
  }
}


export const GameSummaryPage = () => {

  const { activity_key } = useParams()
  const userSession = getUserSession()
  const [activity, setActivity] = useState<LessonActivity>()
  const [game, setGame] = useState<ActivityGame | null>()
  const [gameSession, setGameSession] = useState<GameSession | null>()
  const [latestAttempt, setLatestAttempt] = useState<GameAttempt | null>()
  const [summary, setSummary] = useState<ArcademicsSummary>()

  async function fetchData() {

    function fetchActivity(): Promise<LessonActivity> {
      return apiClient.post(BASE_URL + "studentSession/lessonActivity", {
        lesson_activity_key: activity_key,
        student_key: userSession.studentKey
      }).then((response) => {
        return response.data as LessonActivity
      })
    }

    function fetchSession(): Promise<GameSession> {
      return apiClient.post(BASE_URL + "games/getActivitySession", {
        lesson_activity_key: activity_key,
        student_key: userSession.studentKey
      }).then((response) => {
        return response.data
      })
    }

    function fetchGame(id: number) {
      return gamesLookupService.getGame(id)
    }

    fetchActivity()
      .then(_activity => {
        setActivity(_activity)

        fetchGame(_activity.fk_activity_node_id)
          .then(_game => {
            setGame(_game)
          })
      })

    fetchSession()
      .then(_session => {
        setGameSession(_session)
      })
  }


  useEffect(() => {
    fetchData().then()
  }, [])

  useEffect(() => {
    if (gameSession) {

      gameSession.gameSessions.sort( (e1,e2) => {
        return e2.created_on.localeCompare(e1.created_on);
      })

      const _latestAttempt = gameSession.gameSessions[0];

      const _summary = new ArcademicsSummary(_latestAttempt?.provider_response ?? [])
      _summary.compute()
      setSummary(_summary)
      setLatestAttempt(_latestAttempt)
    }
  }, [gameSession])

  const summaryLabelStyle: StandardLonghandProperties = {
    width: '12em', fontWeight: 'bold'
  }
  const summaryValueStyle: StandardLonghandProperties = {
    width: '12em'
  }

  const allQuestions = latestAttempt?.provider_response
    .flatMap(e=>e)
    .flatMap(e=> e.responses) ?? [];


  return (
    <div className="page-wrapper">
      <div className="cs-pg-header bg-dark-blue py-4">
        <Header
          title={game?.name}
          subjectId={activity?.fk_sub_id}
          activityTypeName={"Game"}
          coinsEarned={gameSession?.rewards.coinsEarned}
          coinsPossible={GameMetatdata.coinsPerGame}
        />
      </div>

      <div>

        <div className="w-85 m-auto font-size-20">

          <div className="mt-3 mb-3">
            <div className="d-flex mb-1">
              <div style={summaryLabelStyle}>Total Attempts</div>
              <div style={summaryValueStyle}>{summary?.totalAttempts}</div>
            </div>
            <div className="d-flex mb-1">
              <div style={summaryLabelStyle}>Correct Attempts</div>
              <div style={summaryValueStyle}>{summary?.correctAttempts}</div>
            </div>
            <div className="d-flex mb-1">
              <div style={summaryLabelStyle}>Accuracy</div>
              <div style={summaryValueStyle}>{summary?.accuracy}%</div>
            </div>
          </div>

          <table className="table table-striped">
            <thead>
            <tr>
              <th className="w-50">Question</th>
              <th className="w-25">Correct?</th>
              {/*<th className="w-25">Time Taken (seconds)</th>*/}
            </tr>
            </thead>
            <tbody>
            {
              allQuestions.map(attempt => {
                return (<tr>
                  <td className=""><div>{attempt.question}</div></td>
                  <td className="">

                    {!!attempt.correct &&
                      <div className="badge" style={{backgroundColor: '#0a9d5a'}}>
                        correct
                      </div>
                    }
                    {!attempt.correct &&
                      <div className="badge" style={{backgroundColor: '#ff0000'}}>
                        wrong
                      </div>
                    }

                  </td>
                  {/*<td className="" style={{textAlign: 'center'}}>{attempt.time / 1000}</td>*/}
                </tr>)
              })
            }
            </tbody>
          </table>
        </div>



      </div>

    </div>

  )

}